export enum FormStyleEnum {
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal',
}
